<template>
    <Dialog title="Edit HubSpot Rule" :show="isOpen" :onClose="onClose">
        <el-form :model="item" label-width="160px" label-position="left" size="small">
            <el-form-item label="Anima event" required>
                <el-select
                    v-model="item.event_action"
                    placeholder="Select..."
                    filterable
                    :loading="loading.events"
                    loading-text="Loading..."
                >
                    <el-option
                        v-for="event in events"
                        :key="event"
                        :label="event"
                        :value="event"
                    />
                </el-select>
            </el-form-item>
            <el-form-item label="HubSpot event name" required>
                <el-input v-model="item.hubspot_event_name" />
            </el-form-item>
            <el-form-item label="HubSpot event ID" required>
                <el-input v-model="item.hubspot_event_id" />
            </el-form-item>
        </el-form>
        <div class="properties-title">
            <h3>Properties</h3>
            <el-button type="primary" size="mini" icon="el-icon-plus" @click="addProperty" round> Add</el-button>
        </div>
        <el-form :model="item.hubspot_properties_map" label-width="160px" label-position="left" size="small">
            <el-form-item v-if="item.hubspot_properties_map && item.hubspot_properties_map.length > 0">
                <el-row :gutter="gutter">
                    <el-col :span="inputSpan" class="column-header">Anima</el-col>
                    <el-col :span="inputSpan" class="column-header">HubSpot</el-col>
                </el-row>
            </el-form-item>
            <el-form-item :label="`Property ${index + 1}`" v-for="(prop, index) in item.hubspot_properties_map" :key="index">
                <el-row :gutter="gutter">
                    <el-col :span="inputSpan">
                        <el-input placeholder="Anima property" v-model="prop.anima_parameter_name" />
                    </el-col>
                    <el-col :span="inputSpan">
                        <el-input placeholder="Hubspot property" v-model="prop.hubspot_property_name" />
                    </el-col>
                    <el-col :span="actionSpan">
                        <el-link type="danger" @click="removeProperty(index)">Remove</el-link>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="save">{{ item.id ? 'Save' : 'Create' }}</el-button>
                <el-button @click="onClose()">Cancel</el-button>
            </el-form-item>
        </el-form>
    </Dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Dialog from '@/components/Dialog';
import { defaultPropertyMapObject } from '../constants';

export default {
    data() {
        return {
            gutter: 10,
            inputSpan: 9,
            actionSpan: 4
        };
    },
    props: {
        item: Object,
        isOpen: Boolean,
        onClose: Function,
    },
    components: {
        Dialog,
    },
    computed: {
        ...mapGetters(['events', 'loading']),
    },
    methods: {
        ...mapActions(['getHubspotRules']),
        addProperty() {
            const properties = this.item.hubspot_properties_map;
            const item = Object.assign({}, defaultPropertyMapObject);
            properties.push(item);
        },
        removeProperty(index) {
            const properties = this.item.hubspot_properties_map;
            properties.splice(index, 1);
        },
        async save() {
            try {
                const {
                    id,
                    event_action,
                    hubspot_event_name,
                    hubspot_event_id,
                } = this.item;

                if (!event_action || !hubspot_event_name || !hubspot_event_id) {
                    return this.$message.error('Please fill all mandatory fields');
                }

                await this.$api({
                    url: `/marketing/hubspot/rule/${id || ''}`,
                    method: id ? 'put' : 'post',
                    data: this.item
                });

                this.$message.success(`${id ? 'Saved' : 'Created'} successfully`);
                this.onClose();
            } catch (e) {
                this.$notify.error({
                    title: 'Failed saving rule',
                    message: e.message,
                });
            } finally {
                this.getHubspotRules();
            }
        }
    }
}
</script>

<style scoped>
.properties-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.properties-title > h3 {
    margin-right: 5px;
}
.column-header {
    font-weight: bold;
    margin-left: 5px;
}
</style>
